/* ローダー関連のデータ */

const state = {
  status: false,
  wait: false,
  login: false
}

const getters = {
  status (state) {
    return state.status
  },
  statusWait (state) {
    return state.wait
  },
  statusLogin (state) {
    return state.login
  }
}

const actions = {
  loadStart (context) {
    return new Promise((resolve) => {
      context.commit('loadStart')

      // 保険
      setTimeout(function () {
        if (context.state.status) {
          context.commit('loadFinish')
        }
      }, 5000)

      resolve()
    })
  },
  loadFinish (context) {
    return new Promise((resolve) => {
      context.commit('loadFinish')

      resolve()
    })
  },
  waitStart (context) {
    return new Promise((resolve) => {
      context.commit('waitStart')

      setTimeout(function () {
        if (context.state.wait) {
          context.commit('waitFinish')
        }
      }, 5000)

      resolve()
    })
  },
  waitFinish (context) {
    return new Promise((resolve) => {
      context.commit('waitFinish')

      resolve()
    })
  },
  loadLoginStart (context) {
    return new Promise((resolve) => {
      context.commit('loadLoginStart')

      // 保険
      setTimeout(function () {
        if (context.state.login) {
          context.commit('loadLoginFinish')
        }
      }, 5000)

      resolve()
    })
  },
  loadLoginFinish (context) {
    return new Promise((resolve) => {
      context.commit('loadLoginFinish')

      resolve()
    })
  }
}

const mutations = {
  loadStart (state) {
    state.status = true
  },
  loadFinish (state) {
    state.status = false
  },
  waitStart (state) {
    state.wait = true
  },
  waitFinish (state) {
    state.wait = false
  },
  loadLoginStart (state) {
    state.login = true
  },
  loadLoginFinish (state) {
    state.login = false
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/modules/store/modules/loading.js